import { useAuthGrantStore } from "App/Routes/AuthGrant/Store";
import { IdActions } from "App/Routes/AuthGrant/Store/IdList";
import React, { useMemo } from "react";
import { FilterItem, InputNumber } from "../../formStyle";
import { GrantKey } from "App/Routes/AuthGrant/Store/Grant";

export const CountFilter = () => {
  const [{ mode, searchList }, dispatch] = useAuthGrantStore(store => store.IdList);

  const count = useMemo(() => {
    switch (mode) {
      case GrantKey.TRACK:
        return searchList.Track.count;
      case GrantKey.ARTIST:
        return searchList.Artist.count;
      case GrantKey.GENRE:
        return searchList.Genre.count;
      case GrantKey.PLAYLIST:
        return searchList.Playlist.count;
      case GrantKey.COMPANY:
        return searchList.Company.count;
      default:
        break;
    }
  }, [mode, searchList.Artist.count, searchList.Genre.count, searchList.Playlist.count, searchList.Track.count, searchList.Company.count]);

  const onChangeNumber = (num: number) => {
    dispatch(IdActions.setCount({ idType: mode, count: num }));
  };

  return (
    <FilterItem>
      <div className="item-label">
        <span>검색 개수</span>
      </div>
      <div className="item-option-wrapper">
        <div className="item-option">
          <InputNumber key={mode} min={1} max={99999} step={1} placeholder="최소" defaultValue={count} onBlur={onChangeNumber} />
        </div>
        <span style={{ display: "flex", alignItems: "center" }}>개</span>
      </div>
    </FilterItem>
  );
};
